import script from "./StakeHoldersSection.vue?vue&type=script&setup=true&lang=js"
export * from "./StakeHoldersSection.vue?vue&type=script&setup=true&lang=js"

import "./StakeHoldersSection.vue?vue&type=style&index=0&id=455c5f88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-455c5f88"]])

export default __exports__